import { getApi } from "./api_instance";

export const retirementReports = async ({ fromDate, toDate, dispatch }) => {
  try {
    const { data } = await getApi({
      apiUrl: `/projects/api/holdings/report?toDate=${toDate}&fromDate=${fromDate}`,
      sendToken: true,
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
